import restClient from '../restClient';
export const GET_TAX_RELATION_COUNTRIES = 'GET_TAX_RELATION_COUNTRIES';
export const POST_TAX_RELATIONS = 'POST_TAX_RELATIONS';
export const FETCHING_TAX_RELATION_COUNTRIES = 'FETCHING_TAX_RELATION_COUNTRIES';
export const TAX_RELATIONS_SAVE_ERROR = 'TAX_RELATIONS_SAVE_ERROR';
const doGetTaxRelationCountries = countries => ({
  countries,
  type: GET_TAX_RELATION_COUNTRIES
});
const fetchingTaxRelationCountries = () => ({
  type: FETCHING_TAX_RELATION_COUNTRIES
});
export const getTaxRelationCountries = () => async dispatch => {
  dispatch(fetchingTaxRelationCountries());
  const countries = await restClient.getTaxRelationCountries();
  dispatch(doGetTaxRelationCountries(countries));
};
const taxRelationSectionSubmitted = () => ({
  type: POST_TAX_RELATIONS
});
export const submitTaxRelationSection = taxRelations => async dispatch => {
  try {
    await restClient.submitTaxRelationSection(taxRelations);
    dispatch(taxRelationSectionSubmitted());
  } catch (e) {
    dispatch({
      type: TAX_RELATIONS_SAVE_ERROR,
      error: e
    });
  }
};